"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BANNER_PAGINATION_WIDTH = exports.BANNER_PAGINATION_MARGIN_RIGHT = exports.BANNER_PAGINATION_MARGIN_LEFT = exports.BANNER_PAGINATION_HEIGHT = exports.BANNER_PAGINATION_COLOR = void 0;
var BANNER_PAGINATION_WIDTH = 8;
exports.BANNER_PAGINATION_WIDTH = BANNER_PAGINATION_WIDTH;
var BANNER_PAGINATION_HEIGHT = 8;
exports.BANNER_PAGINATION_HEIGHT = BANNER_PAGINATION_HEIGHT;
var BANNER_PAGINATION_MARGIN_LEFT = 3;
exports.BANNER_PAGINATION_MARGIN_LEFT = BANNER_PAGINATION_MARGIN_LEFT;
var BANNER_PAGINATION_MARGIN_RIGHT = 3;
exports.BANNER_PAGINATION_MARGIN_RIGHT = BANNER_PAGINATION_MARGIN_RIGHT;
var BANNER_PAGINATION_COLOR = {
  INACTIVE: 'greyMedium',
  ACTIVE: 'default'
};
exports.BANNER_PAGINATION_COLOR = BANNER_PAGINATION_COLOR;